import VM from 'scratch-vm';
import storage from '../lib/storage';

import customExtensions from '../lib/custom-extensions';

const SET_VM = 'scratch-gui/vm/SET_VM';
const defaultVM = new VM();
defaultVM.attachStorage(storage);

// Patch loadExtensionURL to support customExtensions when loading projects
const originalLoadExtensionURL = defaultVM.extensionManager.loadExtensionURL.bind(defaultVM.extensionManager);
defaultVM.extensionManager.loadExtensionURL = function (url) {
    if (customExtensions[url]) {
        if (!this.isExtensionLoaded(url)) {
            const ExtensionClass = customExtensions[url];
            const extInstance = new ExtensionClass(this.runtime);
            const serviceName = this._registerInternalExtension(extInstance);
            this._loadedExtensions.set(url, serviceName);
        }
        return Promise.resolve();
    }
    return originalLoadExtensionURL(url);
}.bind(defaultVM.extensionManager);

const initialState = defaultVM;

const reducer = function (state, action) {
    if (typeof state === 'undefined') state = initialState;
    switch (action.type) {
    case SET_VM:
        return action.vm;
    default:
        return state;
    }
};
const setVM = function (vm) {
    return {
        type: SET_VM,
        vm: vm
    };
};

export {
    reducer as default,
    initialState as vmInitialState,
    setVM
};
